<template>
  <el-dialog title="新建流程图" :visible.sync="isVisibleTemp" width="50%">
    <el-form class="saveFlowChart" :model="flowChart" :rules="rules" ref="saveFlowChart" label-width="100px">
      <el-form-item label="名称" prop="flowName">
        <el-input class="eb-input" v-model="flowChart.flowName"></el-input>
      </el-form-item>
      <el-form-item label="描述" prop="flowInfo">
        <el-input class="eb-input" v-model="flowChart.flowInfo"></el-input>
      </el-form-item>
      <el-form-item label="应用流程" prop="flowType">
        <el-select class="eb-select" v-model="flowChart.flowType" clearable placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button class="eb-button-orange eb-button-big" @click="submitForm('saveFlowChart')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { saveFlowChart, getFlowChartTemNameByRoleId } from '@/services/flowchart-service';
export default {
  name: 'saveFlowChart',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      flowChart: {
        createId: this.$store.state.user.userInfo.userid,
        flowName: '',
        flowInfo: '',
        flowType: null
      },
      rules: {
        flowName: [{ required: true, message: '请输入活动名称', trigger: 'blur' }]
      },
      options: [],
      user: this.$store.state.user.userInfo
    };
  },
  computed: {
    isVisibleTemp: {
      get: function() {
        return this.isVisible;
      },
      set: function(val) {
        this.$emit('update:isVisible', val);
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    submitForm: function(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.saveFlowChartService();
        } else {
          return false;
        }
      });
    },
    init: function() {
      this.options = getFlowChartTemNameByRoleId(this.user.roleid, this.user.userRoles);
    },
    async saveFlowChartService() {
      try {
        let { data } = await saveFlowChart(this.flowChart);
        if (data.returnCode === '01') {
          window.open('/flowchart/edit/' + data.flowId);
          this.isVisibleTemp = false;
          this.$message.success('新家流程成功');
          this.$emit('onSuccessSaveFlowChart');
        } else if (data.returnCode === '03') {
          this.$message.error(data.message);
        } else if (data.returnCode === '04') {
          this.$message.error(data.message);
        } else {
          this.$message.error('新建流程图失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    }
  }
};
</script>
